import { ChangeDetectionStrategy, Component, HostListener, Inject, computed, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DialogCounterService } from '@ms/core/components/dialog/service/dialog-counter.service';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslatePipe } from '@ngx-translate/core';
import { equalPrimitives } from 'app/main/shared/utils';

export interface ConfirmValue {
    title: string;
    value: boolean | string | Date | number;
    type: 'string' | 'boolean' | 'date' | 'number';
    name: string;
    required: boolean;
}

@Component({
    selector: 'fuse-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    imports: [
        MatDialogModule,
        MatButtonModule,
        TranslatePipe,
        FlexLayoutModule,
        MatCheckboxModule,
        FormsModule,
        MatInputModule,
        MatDatepickerModule,
        MatFormFieldModule,
    ],
    providers: [provideDateFnsAdapter()],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FuseConfirmDialogComponent {
    confirmMessage: string;
    title: string;
    yesCaption: string;
    noCaption: string;
    optionValues = signal<ConfirmValue[]>([], { equal: equalPrimitives });
    showCancel = false;

    constructor(
        public dialogRef: MatDialogRef<FuseConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.confirmMessage = data.confirmMessage;
        this.title = data.title || 'Confirm';
        this.yesCaption = data.yesCaption || 'GENERAL.BUTTON.YES';
        this.noCaption = data.noCaption || 'GENERAL.BUTTON.NO';
        this.showCancel = data.showCancel;
        this.optionValues.set(data.options);
        this.dialogRef.disableClose = true;
    }

    @HostListener('window:keyup.esc') onKeyUp() {
        if (DialogCounterService.currentDialog[DialogCounterService.currentDialog.length - 1] == this.dialogRef.id) {
            if (this.dialogRef) {
                this.dialogRef.close();
            }
        }
    }

    onNoClick(): void {
        if (this.dialogRef) {
            this.dialogRef.close('no');
        }
    }

    onCancelClick() {
        if (this.dialogRef) {
            this.dialogRef.close('cancel');
        }
    }

    onYesClick(): void {
        if (this.optionValues()?.length > 0 && this.dialogRef) {
            const result = { yesClick: true };
            this.optionValues().forEach(o => {
                result[o.name] = o.value;
            });
            this.dialogRef.close(result);
        } else {
            if (this.dialogRef) {
                this.dialogRef.close('yes');
            }
        }
    }

    isNotValid = computed(() => {
        if (this.optionValues()?.length > 0) {
            this.optionValues().forEach(item => {
                if (item.required && !item.value) {
                    return true;
                }
            });
            return false;
        } else {
            return false;
        }
    });
}
